export default __webpack_public_path__ + "static/media/cycling_weekly.7ab94f1f.jpg";